import styled from 'styled-components';
import media from 'styled-media-query';
import Img from 'gatsby-image';
import LocalizedLink from '../LocalizedLink';

export const PostItemLink = styled(LocalizedLink)`
  text-decoration: none;
  display: block;
  margin: 1.5rem;
  flex: 1 1 350px;
  max-width: 350px;
  transition: transform 0.5s ease;

  &:hover {
    transform: translateY(-3px);

    div::before {
      box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 0px 100vw inset;
    }
  }

  

`;

export const PostItemWrapper = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0 10px 8px -8px rgba(0, 0, 0, 0.3);
}
`;

// export const PostItemImg = styled.img`
//   display: block;
// `

export const PostItemImg = styled(Img)`
  width: 100%;

  &::before {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 0px 100vw inset; /* dark overlay */
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10;
  }

`;

export const PostItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4rem 3rem;
  position: relative;
  ${'' /* text-align: center; */}
`;

export const PostItemTag = styled.span`
  display: inline-block;
  align-items: center;
  background: ${props =>
    props.background ? props.background : 'red'};
  color: #fff;
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: calc(var(--space-sm) / 1.5) var(--space-sm);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

export const PostItemCategory = styled.div`
  background-color: var(--primary-color);
  font-size: 100%;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 140%;
  color: #000;
  padding: .8rem;
  position: absolute;
  text-transform: lowercase;
  
  top: -20px;
  left: -.5px;
  z-index: 15;
`

export const PostItemDate = styled.time`
  font-size: 1.4rem;
  margin-bottom: var(--space-sm);
`;

export const PostItemTitle = styled.h1`
  font-size: 100%;
`;

export const PostItemSubtitle = styled.h2`
  font-size: 130%;
  font-weight: 600;
  letter-spacing: .5px;
  margin-bottom: 1rem;

  ${media.greaterThan('small')`
    white-space: nowrap;
`}  
`;

export const PostItemDescription = styled.p`
  font-size: 110%;
  color: var(--text-color);
  margin-top: var(--space-sm);

  &:after {
    content: '';
      display: inline-block;
      width: 30px;
      height: 4px;
      background: var(--primary-color);
      margin-left: 1rem;
  }
`;


